import { doc, updateDoc } from 'firebase/firestore';

export const markLastMessageAsRead = async (db, chatId) => {
  try {
    await updateDoc(doc(db, 'chats', chatId), {
      'lastMessage.readed': true,
    });
  } catch (error) {
    console.error('Failed to mark message as read:', error);
  }
};
